import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"
import { checkIfTimesAreEquals, isNgbDate, ngbDateToDate } from "./ngBootstrap"
import { checkIfIsPreviousDay } from "./utilBoostrap"

export function invalidDateFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value

        if (!value) return { required: true }

        if (isNgbDate(value)) return null

        return { invalidFormat: true }
    }
}

export function passedDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const baseValidator = invalidDateFormatValidator()(control)

        if (baseValidator) return baseValidator

        const value = control.value

        const valueDate = ngbDateToDate(value)

        const today = new Date()

        if (!checkIfIsPreviousDay(valueDate, today)) return null

        return { passedDate: true }
    }
}

export function notBlankValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value

        if (!value) return { required: true }

        return control.value.trim() ? null : { notBlank: true }
    }
}

export function equalsTimeValidator(firstDate: string, secondDate: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const firstValue = control.get(firstDate)
        const secondValue = control.get(secondDate)

        if (!firstValue || !secondValue) return null

        const areEquals = checkIfTimesAreEquals(firstValue.value, secondValue.value)

        return areEquals ? { timesAreEqual: true } : null
    }
}